// extracted by mini-css-extract-plugin
export default {"zoomModal":"T0-z"};